import { getState } from './state';
import { createSelector } from 'reselect';

export const getAltchaSlice = createSelector([getState], slice => {
  return slice.altcha;
});
/**
 * Get the altcha verification token from state
 */
export const getAltchaToken = (state: any): string | undefined => {
  const damzState = getAltchaSlice(state);
  return damzState?.verificationToken;
};
